import { accessTokenRequest } from '../../config/msalConfig'
import { msalInstance } from '../../msalClient'

/**
 * Please note that this method functionally does the same as
 * the setAuthorizationHeader method. The only difference is that
 * we return the actual header here instead of overwriting the given
 * headers. To ensure that the old way still works we'll develop this
 * over time next to the existing solution.
 */
export default async (headers: any) => {
  const { Authorization } = headers

  const jwt = await acquireAccessToken()
  const authorization = Authorization
    ? Authorization.replace('<JWT>', jwt)
    : `Bearer ${jwt}`

  return { Authorization: authorization }
}

const acquireAccessToken = async () => {
  const activeAccount = msalInstance.getActiveAccount()

  if (!activeAccount) {
    throw Error(
      'No active account! Verify a user has been signed in and setActiveAccount has been called.'
    )
  }

  const request = {
    ...accessTokenRequest(),
    account: activeAccount,
  }

  const authResult = await msalInstance.acquireTokenSilent(request)

  return authResult.accessToken
}
